export const en = {
    languages: {
        finland: "Finnish",
        sweden: "Swedish",
        england: "English",
        germany: "Germany",
    },
    rowStatus: {
        new: "New",
        pending: "Pending",
        error: "Error",
        active: "Active",
        null: ""
    },
    common: {
        suppliers: "Suppliers",
        letters: "Letters",
        logout: "Log out",
        servicedesk: "Customer service",
        tos: "Terms of service",
        guide: "Guide",
    },
    login: {
        username: "Username",
        password: "Password",
        login: "Log in",
        info1: "Import your suppliers by file or from Apix system",
        info2: "Keep track of your suppliers and whether they are sending invoices to the right e-invoice address",
        info3: "Inform your suppliers about changes to your e-invoice address by mail or email",
        wrongPass: "Wrong username or password",
        serviceDown: "Service is unavailable Contact servicedesk@apix.fi.",
        accountLocked: "For security reasons, the account will be locked after five (5) invalid attempts have been made to log in to the service. Your account is locked for 5 minutes"

    },
    modal: {
        confirm: "OK",
        cancel: "Cancel",
        confirmSendLetter: "Do you wish to send out {count} notification?",
        confirmSending: "Confirm sending",
        remove: "Confirm remove",
        stop: "Stop"
    },
    letters: {
        select: "Select letter",
        name: "Name",
        remove: "Delete",
        removeAttachment: "Remove attachment",
        update: "Save",
        createNew: "Create new",
        create: "Create",
        downloadPDF: "Download PDF",
        preview: "Preview",
        updated: "Saved",
        subject: "Subject",
        errorUpdating: "Error in updating",
        exampleSentSuccesful: "Test sent",
        errorSendingExample: "Error in sending test",
        errorAdding: "Error adding letter",
        errorRemoving: "Error removing letter",
        removeSuccessful: "Delete succesful",
        addSuccessful: "Letter created",
        sendTest: "Send test email",
        confirmRemove: "Do you wish to remove letter {name}?",
        confirmTest: "Send test email to {email}?",
        userAddressMissing: "Address is missing from user. Update user address from Laskumappi Tools.",
        selectFile: "Select attachment (PDF)",
        attachmentInfo: "When sending as an email the attachment will be added to message. When sending as a letter the attachment will be used as the letter.",
        attachmentInfo2: "Message may be written in multiple languages. Text will be chosen based on recipient's language.",
        attachment: "Attachment",
        exampleEmail: "Sähköpostiosoite"

    },
    supplier: {
        suppliers: "Suppliers",
        name: "Name",
        add: "Add",
        address: "Addresss",
        businessId: "Business ID",
        street1: "Street 1",
        street2: "Street 2",
        postOffice: "City",
        postalCode: "Postalcode",
        countryCode: "Country",
        email: "Email",
        print: "Letter",
        status: "Status",
        "active": "Active",
        "new": "New",
        "pending": "Pending",
        "error": "Error",
        updatedSupplier: "Saved",
        updatedSuppliers: "Suppliers updated: {count}",
        duplicates: "Duplicate suppliers: {count}",
        removeSuccessful: "Supppliers removed: {count}",
        fetched: "List updated",
        confirmRemove: "Do you wish to remove {count} suppliers?",
        cantSendAsEmail: "{name} cannot be send as email",
        containsAttachment: "{name} contains attachment",
        all: "All",
        checkForm: "Form invalid",
        addedSupplier: "Supplier added",
        addedSuppliers: "Suppliers added: {count}",
        operationFailed: "Action failed",
        adder: "Add",
        importer: "Import",
        remover: "Remove",
        sender: "Send",
        main: "Status",

        deleteSupplier: "Remove supplier",
        selectLetter: "-- Select letter --",
        selectDeliveryMethod: "-- Select delivery method --",
        sendLetter: "Send supplier letter",
        invoiceCount: "Invoices",
        lettersSent: "Letters",
        lastLetterSent: "Last letter",
        emailsSent: "Emails",
        lastEmailSent: "Last email",
        language: "Language",
        importSupplier: "Import from file",
        examples: "Download examples",
        selectFile: "Select file",
        selectSuppliers: "Select suppliers",
        selectedSuppliers: "Selected {count} suppliers",
        removeSuppliers: "Remove suppliers",
        ofWhich: ", of which",
        inError: " {count} are in error",
        invalidAddress: "(invalid address or language)",
        missingEmail: "(invalid email or language)",
        validSuppliers: "{count} are valid",
        sending: "Sending",
        sent: "Sent {count}/{total}",
        failedSent: "Failed",
        checkListing: "Check listing",

        import: "Import from file",
        importInstructions1: "Import suppliers from excel- or csv-file. Duplicates based on business id will not be added.",
        importInstructions2: "You may also update suppliers based on business id for the selected columns.",
        downloadExample: "Download example csv and excel files here",
        importSuppliers: "Import from file",
        errorFileType: "Invalid file format",

        importFromSystem: "Import from system",
        importInstructions3: "Missing suppliers will be imported from system.",
        importInstructions4: "Importing may take several minutes.",
        importSuppliersFromSystem: "Import from system",
        importingFromSystem: "Fetching suppliers",
        overwrite: "Overwrite based on business id:",

        texts: {
            count: "Showing {from}-{to} of results|{count} results|One result",
            filter: "Filter:",
            filterPlaceholder: "Search",
            limit: "Pagesize:",
            page: "Page:",
            noResults: "No results",
            filterBy: "Search by {column}",
            loading: "Searching...",
            defaultOption: "Select {column}",
            columns: "Columns"
        },
        statusTexts: {
            "active": "E-invoices received from supplier",
            "new": "No e-invoices received from supplier",
            "pending": "Supplier has been informed, awaiting e-invoices",
            "error": "Print invoices received after informing"
        }
    },
}